export default {
  rooms: {
    icon: "v1/bed-king",
    type: "int",
    name: "rooms",
    label: {
      ar: "عدد الغرف",
      en: "Rooms",
    },
    range: {
      min: 0,
      max: 5,
    },
  },
  beds: {
    showRealValue: true,
    type: "int",
    name: "beds",
    icon: "v1/bed-king",
    label: {
      ar: "غرف النوم",
      en: "Bed rooms",
    },
    options: [
      {
        label: {
          ar: "الكل",
          en: "All",
        },
      },
      {
        label: {
          ar: "1",
          en: "1",
        },
        value: 1,
      },
      {
        label: {
          ar: "2",
          en: "2",
        },
        value: 2,
      },
      {
        label: {
          ar: "3",
          en: "3",
        },
        value: 3,
      },
      {
        label: {
          ar: "4",
          en: "4",
        },
        value: 4,
      },
      {
        label: {
          ar: "5+",
          en: "5+",
        },
        value: {
          gte: 5,
        },
        matcher: "gte,5",
      },
    ],
  },
  livings: {
    showRealValue: true,
    type: "int",
    icon: "v1/couch",
    name: "livings",
    label: {
      ar: "الصالات",
      en: "Living rooms",
    },
    options: [
      {
        label: {
          ar: "الكل",
          en: "All",
        },
      },
      {
        label: {
          ar: "1",
          en: "1",
        },
        value: 1,
      },
      {
        label: {
          ar: "2",
          en: "2",
        },
        value: 2,
      },
      {
        label: {
          ar: "3",
          en: "3",
        },
        value: 3,
      },
      {
        label: {
          ar: "4",
          en: "4",
        },
        value: 4,
      },
      {
        label: {
          ar: "5+",
          en: "5+",
        },
        value: {
          gte: 5,
        },
        matcher: "gte,5",
      },
    ],
  },
  family: {
    type: "int",
    icon: "v1/id",
    name: "family",
    label: {
      ar: "الفئة",
      en: "Family or single",
    },
    options: [
      {
        label: {
          ar: "الكل",
          en: "Not Defined",
        },
      },
      {
        label: {
          ar: "عزاب",
          en: "Single",
        },
        value: 0,
        path: "/عزاب",
      },
      {
        label: {
          ar: "عوائل",
          en: "Family",
        },
        value: 1,
        path: "/عوائل",
      },
    ],
  },
  rent_period: {
    type: "int",
    name: "rent_period",
    label: {
      ar: "مدة الإيجار",
      en: "Rent period",
    },
    options: [
      {
        label: {
          ar: "الكل",
          en: "Not Defined",
        },
      },
      {
        label: {
          ar: "يومي",
          en: "Daily",
        },
        path: "/يومي",
        value: 1,
      },
      {
        label: {
          ar: "شهري",
          en: "Monthly",
        },
        path: "/شهري",
        value: 2,
      },
      {
        label: {
          ar: "سنوي",
          en: "Yearly",
        },
        path: "/سنوي",
        value: 3,
      },
    ],
  },
  area: {
    icon: "v1/area",
    type: "float",
    name: "area",
    label: {
      ar: "المساحة",
      en: "Area",
    },
    suffix: {
      ar: "م²",
      en: "m²",
    },
  },
  width: {
    type: "float",
    icon: "v1/area",

    name: "width",
    label: {
      ar: "العرض",
      en: "Width",
    },
    suffix: {
      ar: "م",
      en: "m",
    },
  },
  length: {
    type: "float",
    icon: "v1/area",
    name: "length",
    label: {
      ar: "الطول",
      en: "Length",
    },
    suffix: {
      ar: "م",
      en: "m",
    },
  },
  meter_price: {
    type: "float",
    name: "meter_price",
    icon: "v1/meter-roll",
    label: {
      ar: "سعر المتر",
      en: "Meter price",
    },
    suffix: {
      ar: "ريال",
      en: "SAR",
    },
    range: {
      min: 1,
      max: 1000000,
    },
  },
  type: {
    type: "int",
    name: "type",
    icon: "v1/pinned-note",
    label: {
      ar: "الغرض",
      en: "Residential and commercial",
    },
    options: [
      {
        label: {
          ar: "الكل",
          en: "Not Defined",
        },
      },
      {
        label: {
          ar: "سكني",
          en: "Residential",
        },
        value: 1,
        path: "/سكني",
      },
      {
        label: {
          ar: "تجاري",
          en: "Commercial",
        },
        value: 2,
        path: "/تجاري",
      },
      {
        label: {
          ar: "سكني/تجاري",
          en: "Commercial/Residential",
        },
        value: 3,
      },
    ],
  },
  content: {
    type: "string",
    name: "content",
    label: {
      ar: "التفاصيل",
      en: "Description",
    },
  },
  wc: {
    showRealValue: true,
    type: "int",
    icon: "v1/bath",
    name: "wc",
    label: {
      ar: "دورات المياه",
      en: "WC",
    },
    options: [
      {
        label: {
          ar: "الكل",
          en: "All",
        },
      },
      {
        label: {
          ar: "1",
          en: "1",
        },
        value: 1,
      },
      {
        label: {
          ar: "2",
          en: "2",
        },
        value: 2,
      },
      {
        label: {
          ar: "3",
          en: "3",
        },
        value: 3,
      },
      {
        label: {
          ar: "4+",
          en: "4+",
        },
        value: {
          gte: 4,
        },
        matcher: "gte,4",
      },
    ],
  },
  street_width: {
    type: "int",
    icon: "v1/street",
    name: "street_width",
    label: {
      ar: "عرض الشارع",
      en: "Street width",
    },
    suffix: {
      ar: "م",
      en: "m",
    },
    range: {
      min: 5,
      max: 100,
    },
  },
  fl: {
    type: "int",
    name: "fl",
    icon: "v1/stairs",
    label: {
      ar: "الدور",
      en: "Floor",
    },
    options: [
      {
        label: {
          ar: "الكل",
          en: "Unset",
        },
      },
      {
        label: {
          ar: "أرضي",
          en: "Ground",
        },
        value: 1,
      },
      {
        label: {
          ar: "علوي",
          en: "Upper Ground",
        },
        value: 2,
      },
      {
        label: {
          ar: "3",
          en: "3",
        },
        value: 3,
      },
      {
        label: {
          ar: "4",
          en: "4",
        },
        value: 4,
      },
      {
        label: {
          ar: "5",
          en: "5",
        },
        value: 5,
      },
      {
        label: {
          ar: "6",
          en: "6",
        },
        value: 6,
      },
      {
        label: {
          ar: "7",
          en: "7",
        },
        value: 7,
      },
      {
        label: {
          ar: "8",
          en: "8",
        },
        value: 8,
      },
      {
        label: {
          ar: "9",
          en: "9",
        },
        value: 9,
      },
      {
        label: {
          ar: "10",
          en: "10",
        },
        value: 10,
      },
      {
        label: {
          ar: "11",
          en: "11",
        },
        value: 11,
      },
      {
        label: {
          ar: "12",
          en: "12",
        },
        value: 12,
      },
      {
        label: {
          ar: "13",
          en: "13",
        },
        value: 13,
      },
      {
        label: {
          ar: "14",
          en: "14",
        },
        value: 14,
      },
      {
        label: {
          ar: "15",
          en: "15",
        },
        value: 15,
      },
      {
        label: {
          ar: "16",
          en: "16",
        },
        value: 16,
      },
      {
        label: {
          ar: "17",
          en: "17",
        },
        value: 17,
      },
      {
        label: {
          ar: "18",
          en: "18",
        },
        value: 18,
      },
      {
        label: {
          ar: "19",
          en: "19",
        },
        value: 19,
      },
      {
        label: {
          ar: "20+",
          en: "20+",
        },
        value: {
          gte: 20,
        },
        matcher: "gte,20",
      },
    ],
  },
  apts: {
    type: "int",
    name: "apts",
    icon: "v1/door",
    label: {
      ar: "عدد الشقق",
      en: "Apartments",
    },
    options: [
      {
        label: {
          ar: "الكل",
          en: "All",
        },
      },
      {
        label: {
          ar: "بدون شقق",
          en: "None",
        },
        value: 0,
      },
      {
        label: {
          ar: "1",
          en: "1",
        },
        value: 1,
      },
      {
        label: {
          ar: "2",
          en: "2",
        },
        value: 2,
      },
      {
        label: {
          ar: "3",
          en: "3",
        },
        value: 3,
      },
      {
        label: {
          ar: "4",
          en: "4",
        },
        value: 4,
      },
      {
        label: {
          ar: "5",
          en: "5",
        },
        value: 5,
      },
      {
        label: {
          ar: "6",
          en: "6",
        },
        value: 6,
      },
      {
        label: {
          ar: "7",
          en: "7",
        },
        value: 7,
      },
      {
        label: {
          ar: "8",
          en: "8",
        },
        value: 8,
      },
      {
        label: {
          ar: "9",
          en: "9",
        },
        value: 9,
      },
      {
        label: {
          ar: "10",
          en: "10",
        },
        value: 10,
      },
      {
        label: {
          ar: "11",
          en: "11",
        },
        value: 11,
      },
      {
        label: {
          ar: "12",
          en: "12",
        },
        value: 12,
      },
      {
        label: {
          ar: "13",
          en: "13",
        },
        value: 13,
      },
      {
        label: {
          ar: "14",
          en: "14",
        },
        value: 14,
      },
      {
        label: {
          ar: "15",
          en: "15",
        },
        value: 15,
      },
      {
        label: {
          ar: "16",
          en: "16",
        },
        value: 16,
      },
      {
        label: {
          ar: "17",
          en: "17",
        },
        value: 17,
      },
      {
        label: {
          ar: "18",
          en: "18",
        },
        value: 18,
      },
      {
        label: {
          ar: "19",
          en: "19",
        },
        value: 19,
      },
      {
        label: {
          ar: "20",
          en: "20",
        },
        value: 20,
      },
      {
        label: {
          ar: "21",
          en: "21",
        },
        value: 21,
      },
      {
        label: {
          ar: "22",
          en: "22",
        },
        value: 22,
      },
      {
        label: {
          ar: "23",
          en: "23",
        },
        value: 23,
      },
      {
        label: {
          ar: "24",
          en: "24",
        },
        value: 24,
      },
      {
        label: {
          ar: "25",
          en: "25",
        },
        value: 25,
      },
      {
        label: {
          ar: "26",
          en: "26",
        },
        value: 26,
      },
      {
        label: {
          ar: "27",
          en: "27",
        },
        value: 27,
      },
      {
        label: {
          ar: "28",
          en: "28",
        },
        value: 28,
      },
      {
        label: {
          ar: "29",
          en: "29",
        },
        value: 29,
      },
      {
        label: {
          ar: "30+",
          en: "30+",
        },
        value: {
          gte: 30,
        },
        matcher: "gte,30",
      },
    ],
  },
  age: {
    type: "int",
    name: "age",
    icon: "v1/calendar",
    label: {
      ar: "عمر العقار",
      en: "Age less than",
    },
    options: [
      {
        label: {
          ar: "الكل",
        },
      },
      {
        hide: true,
        label: {
          ar: "جديد",
        },
        value: 0,
      },
      {
        label: {
          ar: "جديد",
        },
        value: {
          lte: 1,
        },
        matcher: "lte,1",
      },
      {
        label: {
          ar: "سنتين",
        },
        value: 2,
      },
      {
        label: {
          ar: "3 سنوات",
        },
        value: 3,
      },
      {
        label: {
          ar: "4 سنوات",
        },
        value: 4,
      },
      {
        label: {
          ar: "5 سنوات",
        },
        value: 5,
      },
      {
        label: {
          ar: "6 سنوات",
        },
        value: 6,
      },
      {
        label: {
          ar: "7 سنوات",
        },
        value: 7,
      },
      {
        label: {
          ar: "8 سنوات",
        },
        value: 8,
      },
      {
        label: {
          ar: "9 سنة",
        },
        value: 9,
      },
      {
        label: {
          ar: "10 سنوات",
        },
        value: 10,
      },
      {
        hide: true,
        label: {
          ar: "أكثر من 10 سنوات",
        },
        value: {
          gte: 10,
        },
        matcher: "gte,10",
      },

      {
        label: {
          ar: "11 سنة",
        },
        value: 11,
      },
      {
        label: {
          ar: "12 سنة",
        },
        value: 12,
      },
      {
        label: {
          ar: "13 سنة",
        },
        value: 13,
      },
      {
        label: {
          ar: "14 سنة",
        },
        value: 14,
      },
      {
        label: {
          ar: "15 سنة",
        },
        value: 15,
      },
      {
        label: {
          ar: "16 سنة",
        },
        value: 16,
      },
      {
        label: {
          ar: "17 سنة",
        },
        value: 17,
      },
      {
        label: {
          ar: "18 سنة",
        },
        value: 18,
      },
      {
        label: {
          ar: "19 سنة",
        },
        value: 19,
      },
      {
        label: {
          ar: "20 سنة",
        },
        value: 20,
      },
      {
        label: {
          ar: "21 سنة",
        },
        value: 21,
      },
      {
        label: {
          ar: "22 سنة",
        },
        value: 22,
      },
      {
        label: {
          ar: "23 سنة",
        },
        value: 23,
      },
      {
        label: {
          ar: "24 سنة",
        },
        value: 24,
      },
      {
        label: {
          ar: "25 سنة",
        },
        value: 25,
      },
      {
        label: {
          ar: "26 سنة",
        },
        value: 26,
      },
      {
        label: {
          ar: "27 سنة",
        },
        value: 27,
      },
      {
        label: {
          ar: "28 سنة",
        },
        value: 28,
      },
      {
        label: {
          ar: "29 سنة",
        },
        value: 29,
      },
      {
        label: {
          ar: "30 سنة",
        },
        value: 30,
      },
      {
        label: {
          ar: "31 سنة",
        },
        value: 31,
      },
      {
        label: {
          ar: "32 سنة",
        },
        value: 32,
      },
      {
        label: {
          ar: "33 سنة",
        },
        value: 33,
      },
      {
        label: {
          ar: "34 سنة",
        },
        value: 34,
      },
      {
        label: {
          ar: "35+ سنة",
        },
        value: {
          gte: 36,
        },
        matcher: "gte,36",
      },
    ],
  },
  stores: {
    showRealValue: true,
    type: "int",
    name: "stores",
    label: {
      ar: "عدد المحلات",
      en: "Stores",
    },
    options: [
      {
        label: {
          ar: "1",
          en: "1",
        },
        value: 0,
      },
      {
        label: {
          ar: "2",
          en: "2",
        },
        value: 1,
      },
      {
        label: {
          ar: "3",
          en: "3",
        },
        value: 2,
      },
      {
        label: {
          ar: "4",
          en: "4",
        },
        value: 3,
      },
      {
        label: {
          ar: "5+",
          en: "5+",
        },
        value: {
          gte: 5,
        },
        matcher: "gte,5",
      },
    ],
  },
  wells: {
    type: "int",
    name: "wells",
    label: {
      ar: "عدد الآبار",
      en: "Wells",
    },
    range: {
      min: 0,
      max: 10,
    },
  },
  street_direction: {
    type: "int",
    icon: "v1/campass",
    name: "street_direction",
    label: {
      ar: "الواجهة",
      en: "Street direction",
    },
    options: [
      {
        label: {
          ar: "الكل",
          en: "Not Defined",
        },
      },
      {
        label: {
          ar: "شمال",
          en: "North",
        },
        value: 1,
        path: "/الواجهة-شمال",
      },
      {
        label: {
          ar: "شرق",
          en: "East",
        },
        value: 2,
        path: "/الواجهة-شرق",
      },
      {
        label: {
          ar: "غرب",
          en: "West",
        },
        value: 3,
        path: "/الواجهة-غرب",
      },
      {
        label: {
          ar: "جنوب",
          en: "South",
        },
        value: 4,
        path: "/الواجهة-جنوب",
      },
      {
        label: {
          ar: "شمال شرقي",
          en: "Northeast",
        },
        value: 5,
        path: "/الواجهة-شمال-شرقي",
      },
      {
        label: {
          ar: "جنوب شرقي",
          en: "Southeast",
        },
        path: "/الواجهة-جنوب-شرقي",
        value: 6,
      },
      {
        label: {
          ar: "جنوب غربي",
          en: "Southwest",
        },
        value: 7,
        path: "/الواجهة-جنوب-غربي",
      },
      {
        label: {
          ar: "شمال غربي",
          en: "Northwest",
        },
        path: "/الواجهة-شمال-غربي",
        value: 8,
      },
      {
        label: {
          ar: "3 شوارع",
          en: "3 Streets",
        },
        path: "/تفتح-على-3-شوارع",
        value: 9,
      },
      {
        label: {
          ar: "4 شوارع",
          en: "4 Streets",
        },
        path: "/تفتح-على-4-شوارع",
        value: 10,
      },
    ],
  },
  trees: {
    type: "int",
    name: "trees",
    label: {
      ar: "عدد الأشجار",
      en: "Trees",
    },
    range: {
      min: 0,
      max: 10,
    },
  },
  ac_type: {
    type: "int",
    name: "ac_type",
    label: {
      ar: "نظام التكييف",
      en: "AC Type",
    },
    options: [
      {
        label: {
          ar: "سبليت",
          en: "Split",
        },
        value: "split",
      },
      {
        label: {
          ar: "شباك",
          en: "Window",
        },
        value: "window",
      },
      {
        label: {
          ar: "مركزي",
          en: "Central",
        },
        value: "central",
      },
    ],
  },
  project_name: {
    type: "string",
    name: "project_name",
    label: {
      ar: "اسم المشروع",
      en: "Project Name",
    },
  },
  apartments_count: {
    type: "int",
    name: "apartments_count",
    label: {
      ar: "عدد الشقق",
      en: "Apartments In Villa",
    },
    options: [
      {
        label: {
          ar: "0",
          en: "0",
        },
        value: 0,
      },
      {
        label: {
          ar: "1",
          en: "1",
        },
        value: 1,
      },
      {
        label: {
          ar: "2",
          en: "2",
        },
        value: 2,
      },
      {
        label: {
          ar: "3",
          en: "3",
        },
        value: 3,
      },
      {
        label: {
          ar: "4",
          en: "4",
        },
        value: 4,
      },
      {
        label: {
          ar: "5+",
          en: "5+",
        },
        value: {
          gte: 5,
        },
        matcher: "gte,5",
      },
    ],
  },
  floors_count: {
    showRealValue: true,
    type: "int",
    name: "floors_count",
    label: {
      ar: "عدد الطوابق",
      en: "Floors In Villa",
    },
    options: [
      {
        label: {
          ar: "1",
          en: "1",
        },
        value: 0,
      },
      {
        label: {
          ar: "2",
          en: "2",
        },
        value: 1,
      },
      {
        label: {
          ar: "3",
          en: "3",
        },
        value: 2,
      },
      {
        label: {
          ar: "4",
          en: "4",
        },
        value: 3,
      },
      {
        label: {
          ar: "5+",
          en: "5+",
        },
        value: {
          gte: 5,
        },
        matcher: "gte,5",
      },
    ],
  },
  master_bedroom_count: {
    showRealValue: true,
    type: "int",
    name: "master_bedroom_count",
    label: {
      ar: "غرف ماستر",
      en: "Master Bedrooms",
    },
    options: [
      {
        label: {
          ar: "0",
          en: "0",
        },
        value: 0,
      },
      {
        label: {
          ar: "1",
          en: "1",
        },
        value: 1,
      },
      {
        label: {
          ar: "2",
          en: "2",
        },
        value: 2,
      },
      {
        label: {
          ar: "3",
          en: "3",
        },
        value: 3,
      },
      {
        label: {
          ar: "4",
          en: "4",
        },
        value: 4,
      },
      {
        label: {
          ar: "5+",
          en: "5+",
        },
        value: {
          gte: 5,
        },
        matcher: "gte,5",
      },
    ],
  },
  bedrooms_count: {
    showRealValue: true,
    type: "int",
    name: "bedrooms_count",
    label: {
      ar: "عدد غرف النوم الكلي",
      en: "Bedrooms",
    },
    options: [
      {
        label: {
          ar: "0",
          en: "0",
        },
        value: 0,
      },
      {
        label: {
          ar: "1",
          en: "1",
        },
        value: 1,
      },
      {
        label: {
          ar: "2",
          en: "2",
        },
        value: 2,
      },
      {
        label: {
          ar: "3",
          en: "3",
        },
        value: 3,
      },
      {
        label: {
          ar: "4",
          en: "4",
        },
        value: 4,
      },
      {
        label: {
          ar: "5+",
          en: "5+",
        },
        value: {
          gte: 5,
        },
        matcher: "gte,5",
      },
    ],
  },
  guestsrooms_count: {
    showRealValue: true,
    type: "int",
    name: "guestsrooms_count",
    label: {
      ar: "غرف استقبال/ مجلس",
      en: "Guest Rooms",
    },
    options: [
      {
        label: {
          ar: "0",
          en: "0",
        },
        value: 0,
      },
      {
        label: {
          ar: "1",
          en: "1",
        },
        value: 1,
      },
      {
        label: {
          ar: "2",
          en: "2",
        },
        value: 2,
      },
      {
        label: {
          ar: "3",
          en: "3",
        },
        value: 3,
      },
      {
        label: {
          ar: "4",
          en: "4",
        },
        value: 4,
      },
      {
        label: {
          ar: "5+",
          en: "5+",
        },
        value: {
          gte: 5,
        },
        matcher: "gte,5",
      },
    ],
  },
  driversrooms_count: {
    showRealValue: true,
    type: "int",
    name: "driversrooms_count",
    label: {
      ar: "غرف سائق",
      en: "Driver Rooms",
    },
    options: [
      {
        label: {
          ar: "0",
          en: "0",
        },
        value: 0,
      },
      {
        label: {
          ar: "1",
          en: "1",
        },
        value: 1,
      },
      {
        label: {
          ar: "2",
          en: "2",
        },
        value: 2,
      },
      {
        label: {
          ar: "3",
          en: "3",
        },
        value: 3,
      },
      {
        label: {
          ar: "4",
          en: "4",
        },
        value: 4,
      },
      {
        label: {
          ar: "5+",
          en: "5+",
        },
        value: {
          gte: 5,
        },
        matcher: "gte,5",
      },
    ],
  },
  other_rooms_count: {
    showRealValue: true,
    type: "int",
    name: "other_rooms_count",
    label: {
      ar: "عدد الغرف الاخرى",
      en: "Other Rooms",
    },
    options: [
      {
        label: {
          ar: "0",
          en: "0",
        },
        value: 0,
      },
      {
        label: {
          ar: "1",
          en: "1",
        },
        value: 1,
      },
      {
        label: {
          ar: "2",
          en: "2",
        },
        value: 2,
      },
      {
        label: {
          ar: "3",
          en: "3",
        },
        value: 3,
      },
      {
        label: {
          ar: "4",
          en: "4",
        },
        value: 4,
      },
      {
        label: {
          ar: "5+",
          en: "5+",
        },
        value: {
          gte: 5,
        },
        matcher: "gte,5",
      },
    ],
  },
  external_area: {
    type: "float",
    name: "external_area",
    label: {
      ar: "المساحة الخارجية (م2)",
      en: "External Area (m2)",
    },
  },
  internal_area: {
    type: "float",
    name: "internal_area",
    label: {
      ar: "المساحة الداخلية (م2)",
      en: "Internal Area (m2)",
    },
  },
  insurance: {
    type: "float",
    name: "insurance",
    label: {
      ar: "تأمين",
      en: "Insurance",
    },
    range: {
      min: 1,
      max: 1000000,
    },
  },
  capacity: {
    type: "int",
    name: "capacity",
    label: {
      ar: "السعة",
      en: "Capacity",
    },
    range: {
      min: 1,
      max: 1000000,
    },
  },
  national_address: {
    type: "string",
    name: "national_address",
    label: {
      en: "National Address",
      ar: "العنوان الوطني",
    },
  },
  obligations: {
    type: "string",
    name: "obligations",
    label: {
      en: "Obligations",
      ar: "الالتزامات",
    },
  },
  guarantees_and_their_duration: {
    type: "string",
    name: "guarantees_and_their_duration",
    label: {
      en: "Guarantees And Their Duration",
      ar: "الضمانات ومدتها",
    },
  },
  saudi_code_compliance: {
    type: "string",
    name: "saudi_code_compliance",
    label: {
      en: "Saudi Code Compliance",
      ar: "التزام بالكود السعودي",
    },
  },
  channels: {
    type: "string",
    name: "channels",
    label: {
      en: "Channels",
      ar: "قنوات الإعلان",
    },
  },

  // Price Fields
  price: {
    type: "float",
    name: "price",
    label: {
      ar: "السعر الإجمالي (ريال)",
      en: "Price (SAR)",
    },
  },
  price_2_payments: {
    type: "float",
    name: "price_2_payments",
    label: {
      ar: "السعر النصف سنوي",
      en: "Price (SAR)",
    },
  },
  price_4_payments: {
    type: "float",
    name: "price_4_payments",
    label: {
      ar: "السعر الريع سنوي",
      en: "Price (SAR)",
    },
  },
  price_12_payments: {
    type: "float",
    name: "price_12_payments",
    label: {
      ar: "السعر الشهري",
      en: "Price (SAR)",
    },
  },

  // Boolean Fields
  stairs: {
    type: "boolean",
    name: "stairs",
    label: {
      ar: "درج صالة",
      en: "Stairs",
    },
    value: 1,
  },
  driver: {
    type: "boolean",
    name: "driver",
    label: {
      ar: "غرفة سائق",
      en: "Driver room",
    },
    value: 1,
  },
  maid: {
    type: "boolean",
    name: "maid",
    label: {
      ar: "غرفة خادمة",
      en: "Maid room",
    },
    value: 1,
  },
  pool: {
    type: "boolean",
    name: "pool",
    label: {
      ar: "مسبح",
      en: "Pool",
    },
    value: 1,
    path: "/مسبح",
  },
  furnished: {
    type: "boolean",
    name: "furnished",
    label: {
      ar: "مؤثثة",
      en: "Furnished",
    },
    value: 1,
  },
  fb: {
    type: "boolean",
    name: "fb",
    label: {
      ar: "ملعب كرة قدم",
      en: "Football pitch",
    },
    value: 1,
    path: "/ملعب-كرة-قدم",
  },
  vb: {
    type: "boolean",
    name: "vb",
    label: {
      ar: "ملعب كرة طائرة",
      en: "Volleyball Court",
    },
    value: 1,
    path: "/ملعب-كرة-طائرة",
  },
  tent: {
    type: "boolean",
    name: "tent",
    label: {
      ar: "بيت شعر",
      en: "Tent",
    },
    value: 1,
    path: "/بيت-شعر",
  },
  backyard: {
    type: "boolean",
    name: "backyard",
    label: {
      ar: "حوش",
      en: "Backyard",
    },
    value: 1,
    path: "/حوش",
  },
  ketchen: {
    type: "boolean",
    name: "ketchen",
    label: {
      ar: "مطبخ",
      en: "Kitchen",
    },
    path: "/مطبخ",
    value: 1,
  },
  playground: {
    type: "boolean",
    name: "playground",
    label: {
      ar: "ملاهي",
      en: "Playground",
    },
    value: 1,
    path: "/ملاهي",
  },
  extra_unit: {
    type: "boolean",
    name: "extra_unit",
    label: {
      ar: "ملحق",
      en: "Extra unit",
    },
    path: "/ملحق",
    value: 1,
  },
  car_entrance: {
    type: "boolean",
    name: "car_entrance",
    label: {
      ar: "مدخل سيارة",
      en: "Car entrance",
    },
    value: 1,
    path: "/مدخل-سيارة",
  },
  basement: {
    type: "boolean",
    name: "basement",
    label: {
      ar: "قبو",
      en: "Basement",
    },
    path: "/قبو",
    value: 1,
  },
  lift: {
    type: "boolean",
    name: "lift",
    label: {
      ar: "مصعد",
      en: "Lift",
    },
    value: 1,
  },
  // duplex: {
  //   type: "boolean",
  //   name: "duplex",
  //   label: {
  //     ar: "دوبلكس",
  //     en: "Duplex",
  //   },
  //   value: 1,
  // },
  ac: {
    type: "boolean",
    name: "ac",
    label: {
      ar: "مكيف",
      en: "Air conditioned",
    },
    value: 1,
  },
  family_section: {
    type: "boolean",
    name: "family_section",
    label: {
      ar: "قسم عوائل",
      en: "Family section",
    },
    path: "/قسم-عوائل",
    value: 1,
  },
  water_availability: {
    type: "boolean",
    name: "water_availability",
    label: {
      ar: "توفر الماء",
      en: "Water",
    },
    value: 1,
  },
  electrical_availability: {
    type: "boolean",
    name: "electrical_availability",
    label: {
      ar: "توفر الكهرباء",
      en: "Electricity",
    },
    value: 1,
  },
  private_roof: {
    type: "boolean",
    name: "private_roof",
    label: {
      ar: "سطح خاص",
      en: "Private Roof",
    },
    value: 1,
  },
  apartment_in_villa: {
    type: "boolean",
    name: "apartment_in_villa",
    label: {
      ar: "في فيلا",
      en: "In Villa",
    },
    value: 1,
  },
  two_entrances: {
    type: "boolean",
    name: "two_entrances",
    label: {
      ar: "مدخلين",
      en: "Two Entrances",
    },
    value: 1,
  },
  special_entrance: {
    type: "boolean",
    name: "special_entrance",
    label: {
      ar: "مدخل خاص",
      en: "Special Entrance",
    },
    value: 1,
  },
  drainage_availability: {
    type: "boolean",
    name: "drainage_availability",
    label: {
      ar: "توفر صرف صحي",
      en: "Drainage availability",
    },
    value: 1,
  },
  men_place: {
    type: "boolean",
    name: "men_place",
    label: {
      ar: "مجلس رجال",
      en: "Men place",
    },
    value: 1,
  },
  women_place: {
    type: "boolean",
    name: "women_place",
    label: {
      ar: "مجلس نساء",
      en: "Women place",
    },
    value: 1,
  },
  separated_electrical_meter: {
    type: "boolean",
    name: "separated_electrical_meter",
    label: {
      ar: "عداد كهرباء منفصل",
      en: "Separated Electrical Meter",
    },
    value: 1,
  },
  separated_water_meter: {
    type: "boolean",
    name: "separated_water_meter",
    label: {
      ar: "عداد ماء منفصل",
      en: "Separated Water Meter",
    },
    value: 1,
  },
  fiber_optic: {
    type: "boolean",
    name: "fiber_optic",
    label: {
      ar: "ألياف ضوئية",
      en: "Fiber Optic",
    },
    value: 1,
  },
  special_parking: {
    type: "boolean",
    name: "special_parking",
    label: {
      ar: "موقف خاص",
      en: "Special Parking",
    },
    value: 1,
  },
  accept_bank: {
    type: "boolean",
    name: "accept_bank",
    label: {
      ar: "يقبل الدفع بالبنك",
      en: "Accept Bank",
    },
    value: 1,
  },
  raw_land: {
    type: "boolean",
    name: "raw_land",
    label: {
      ar: "أرض خام",
      en: "Empty Land",
    },
    value: 1,
  },
  roof_villa: {
    type: "boolean",
    name: "roof_villa",
    label: {
      ar: "فيلا في السطح",
      en: "Roof Villa",
    },
    value: 1,
  },
  laundry_room: {
    type: "boolean",
    name: "laundry_room",
    label: {
      ar: "غرفة غسيل",
      en: "Laundry Room",
    },
    value: 1,
  },
  apartment_in_project: {
    type: "boolean",
    name: "apartment_in_project",
    label: {
      ar: "شقة في مشروع",
      en: "In Project",
    },
    value: 1,
  },
  upper_extension: {
    type: "boolean",
    name: "upper_extension",
    label: {
      ar: "ملحق علوي",
      en: "Upper Extension",
    },
    value: 1,
  },
  lower_extension: {
    type: "boolean",
    name: "lower_extension",
    label: {
      ar: "ملحق سفلي",
      en: "Lower Extension",
    },
    value: 1,
  },
  balcony: {
    type: "boolean",
    name: "balcony",
    label: {
      ar: "بلكونة/تراس",
      en: "Balcony",
    },
    value: 1,
  },
  master_bedroom: {
    type: "boolean",
    name: "master_bedroom",
    label: {
      ar: "غرفة نوم ماستر",
      en: "Master Bedroom",
    },
    value: 1,
  },
  wifi: {
    type: "boolean",
    name: "wifi",
    label: {
      ar: "توفر واي فاي",
      en: "wifi",
    },
    value: 1,
  },
  washing_machine: {
    type: "boolean",
    name: "washing_machine",
    label: {
      ar: "غسالة",
      en: "Washing Machine",
    },
    value: 1,
  },
  smart_tv: {
    type: "boolean",
    name: "smart_tv",
    label: {
      ar: "تلفاز ذكي",
      en: "Smart Tv",
    },
    value: 1,
  },
  self_entry: {
    type: "boolean",
    name: "self_entry",
    label: {
      ar: "دخول ذاتي",
      en: "Self Entry",
    },
    value: 1,
  },
  oven: {
    type: "boolean",
    name: "oven",
    label: {
      ar: "فرن",
      en: "Oven",
    },
    value: 1,
  },
  sleeping: {
    type: "boolean",
    name: "sleeping",
    label: {
      ar: "يسمح بالمبيت",
      en: "sleeping",
    },
    value: 1,
  },
  heater: {
    type: "boolean",
    name: "heater",
    label: {
      ar: "سخان",
      en: "heater",
    },
    value: 1,
  },
  microphone: {
    type: "boolean",
    name: "microphone",
    label: {
      ar: "مايكروفون",
      en: "microphone",
    },
    value: 1,
  },
  sound_system: {
    type: "boolean",
    name: "sound_system",
    label: {
      ar: "نظام صوتي",
      en: "sound_system",
    },
    value: 1,
  },
  projector: {
    type: "boolean",
    name: "projector",
    label: {
      ar: "بروجكتر",
      en: "projector",
    },
    value: 1,
  },
  grill: {
    type: "boolean",
    name: "grill",
    label: {
      ar: "شواية",
      en: "grill",
    },
    value: 1,
  },
  outdoor_cooling_system: {
    type: "boolean",
    name: "outdoor_cooling_system",
    label: {
      ar: "نظام تبريد خارجي",
      en: "Outdoor Cooling System",
    },
    value: 1,
  },
  iron: {
    type: "boolean",
    name: "iron",
    label: {
      ar: "مكواة",
      en: "iron",
    },
    value: 1,
  },
  smoking: {
    type: "boolean",
    name: "smoking",
    label: {
      ar: "يسمح بالتدخين",
      en: "smoking allowed",
    },
    value: 1,
  },
  special_view: {
    type: "boolean",
    name: "special_view",
    label: {
      ar: "إطلالة خاصة",
      en: "Special View",
    },
    value: 1,
  },
  cleaning_service: {
    type: "boolean",
    name: "cleaning_service",
    label: {
      ar: "خدمة تنظيف",
      en: "Cleaning Service",
    },
    value: 1,
  },
  microwave: {
    type: "boolean",
    name: "microwave",
    label: {
      ar: "مايكرويف",
      en: "Microwave",
    },
    value: 1,
  },
  shampoo: {
    type: "boolean",
    name: "shampoo",
    label: {
      ar: "شامبو",
      en: "Shampoo",
    },
    value: 1,
  },
  towels: {
    type: "boolean",
    name: "towels",
    label: {
      ar: "مناشف",
      en: "Towels",
    },
    value: 1,
  },
  private_beach: {
    type: "boolean",
    name: "private_beach",
    label: {
      ar: "شاطئ خاص",
      en: "Private Beach",
    },
    value: 1,
  },
  cctv: {
    type: "boolean",
    name: "cctv",
    label: {
      ar: "كاميرات مراقبة",
      en: "CCTV",
    },
    value: 1,
  },
  instant_booking: {
    type: "boolean",
    name: "instant_booking",
    label: {
      ar: "حجز فوري",
      en: "Instant Booking",
    },
    value: 1,
  },
  is_constrained: {
    type: "boolean",
    name: "is_constrained",
    label: {
      en: "Constrained",
      ar: "وجود قيد",
    },
    value: 1,
  },
  is_pawned: {
    type: "boolean",
    name: "is_pawned",
    label: {
      en: "Pawned",
      ar: "مرهون",
    },
    value: 1,
  },
  near_bus: {
    type: "boolean",
    name: "near_bus",
    label: {
      ar: "قريب من محطة باص",
      en: "Near Bus",
    },
    value: 1,
  },
  near_metro: {
    type: "boolean",
    name: "near_metro",
    label: {
      ar: "قريب من محطة مترو",
      en: "Near Metro",
    },
    value: 1,
  },
  villa_type: {
    type: "string",
    icon: "v1/id",
    name: "villa_type",
    label: {
      ar: "الفئة",
      en: "Villa Type",
    },
    options: [
      {
        label: {
          ar: "الكل",
          en: "Not Defined",
        },
      },
      {
        label: {
          ar: "فيلا مستقلة",
          en: "Standalone",
        },
        value: "standalone",
        path: "/فيلا-مستقلة",
      },
      {
        label: {
          ar: "دوبلكس",
          en: "Duplex",
        },
        value: "duplex",
        path: "/دوبلكس",
      },
      {
        label: {
          ar: "تاون هاوس",
          en: "Townhouse",
        },
        value: "townhouse",
        path: "/تاون-هاوس",
      },
    ],
  },
};
